import React from "react";
import { Tag } from "primereact/tag";
import { Tooltip } from "primereact/tooltip";
import { RealtimeStatus } from "../hooks/useScheduleRealtime";

interface LiveStatusIndicatorProps {
  status: RealtimeStatus;
}

const STATUS_CONFIG: Record<
  RealtimeStatus,
  { label: string; tooltip: string; className: string; icon: string }
> = {
  live: {
    label: "Live",
    tooltip: "Receiving live schedule updates",
    className: "live-status-indicator--live",
    icon: "pi pi-circle-fill",
  },
  reconnecting: {
    label: "Reconnecting…",
    tooltip: "Trying to reconnect",
    className: "live-status-indicator--reconnecting",
    icon: "pi pi-circle-fill",
  },
  offline: {
    label: "Offline",
    tooltip: "Live updates unavailable",
    className: "live-status-indicator--offline",
    icon: "pi pi-circle-fill",
  },
};

export const LiveStatusIndicator: React.FC<LiveStatusIndicatorProps> = ({
  status,
}) => {
  const config = STATUS_CONFIG[status];

  return (
    <>
      <Tooltip target=".live-status-indicator" position="bottom" />
      <Tag
        value={config.label}
        icon={config.icon}
        className={`schedule-remark-chip live-status-indicator ${config.className}`}
        data-pr-tooltip={config.tooltip}
        data-pr-position="bottom"
      />
      <style>
        {`
          .live-status-indicator .p-tag-icon {
            font-size: 0.5rem;
            margin-right: 0.35rem;
          }
          .live-status-indicator--live .p-tag-icon {
            color: var(--green-500);
          }
          .live-status-indicator--live {
            color: var(--green-700) !important;
            border-color: var(--green-200) !important;
          }
          .live-status-indicator--reconnecting .p-tag-icon {
            color: var(--orange-500);
          }
          .live-status-indicator--reconnecting {
            color: var(--orange-700) !important;
            border-color: var(--orange-200) !important;
          }
          .live-status-indicator--offline .p-tag-icon {
            color: var(--surface-500);
          }
          .live-status-indicator--offline {
            color: var(--text-color-secondary) !important;
          }
        `}
      </style>
    </>
  );
};
